export default __webpack_public_path__ + "static/media/Impact.12d9cedc.png";